export const invertedMessages = {
  'Campaign progress job is running in background':
    'Cert.Campaignprogressjobisrunninginbackground.label',
  'Progress is being updated': 'Cert.Progressisbeingupdated.label',
};
